/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddressDto } from '../models/AddressDto';
import type { AutocompleteQueryDto } from '../models/AutocompleteQueryDto';
import type { ReverseGeocodeDto } from '../models/ReverseGeocodeDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AutocompleteService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get address autocomplete suggestions
     * Returns address autocomplete suggestions using Google Places API. Requires authentication.
     * @returns any Autocomplete suggestions returned successfully.
     * @throws ApiError
     */
    public autocompleteControllerGetAutocompleteSuggestions({
        requestBody,
    }: {
        requestBody: AutocompleteQueryDto,
    }): CancelablePromise<Array<{
        placeId?: string;
        description?: string;
        city?: string;
        country?: string;
        line1?: string;
        postalCode?: string;
        state?: string;
        lat?: number;
        lng?: number;
    }>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/autocomplete',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized.`,
                501: `Google Maps API key not configured.`,
            },
        });
    }
    /**
     * Reverse geocode coordinates to an address
     * Resolves a latitude/longitude pair into a structured address (street number, street, city, ZIP, state, country) using the Google Geocoding API. Requires authentication.
     * @returns AddressDto Address resolved successfully from the provided coordinates.
     * @throws ApiError
     */
    public autocompleteControllerReverseGeocode({
        requestBody,
    }: {
        requestBody: ReverseGeocodeDto,
    }): CancelablePromise<AddressDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/autocomplete/reverse',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error. Check that lat is in [-90, 90] and lng is in [-180, 180].`,
                401: `Unauthorized.`,
                501: `Google Maps API key not configured.`,
                502: `Google Geocoding API request failed.`,
            },
        });
    }
}
